import {
  describePlan,
  formatPrice,
  PROMOTION_PLANS,
  type Currency,
  type PromotionPlanId,
} from '@talkofthetown/shared';
import { currencies } from '../hooks/useCurrency';

interface Props {
  value: PromotionPlanId | null;
  onChange: (plan: PromotionPlanId | null) => void;
  currency: Currency;
  onCurrencyChange: (currency: Currency) => void;
  /** Offer "Not now" as a choice too (when promoting is optional, as while posting). */
  optional?: boolean;
}

/** The promotion plans with their prices, one to pick, and the currency to pay in. */
export function PlanPicker({
  value,
  onChange,
  currency,
  onCurrencyChange,
  optional = false,
}: Props) {
  const other = currencies.find((c) => c !== currency);
  return (
    <>
      <div className="promote__plans" role="radiogroup" aria-label="Promotion">
        {optional && (
          <label className="promote__plan">
            <input
              type="radio"
              name="promote-plan"
              checked={value === null}
              onChange={() => onChange(null)}
            />
            <span>Not now</span>
            <strong>Free</strong>
          </label>
        )}
        {PROMOTION_PLANS.map((p) => (
          <label key={p.id} className="promote__plan">
            <input
              type="radio"
              name="promote-plan"
              value={p.id}
              checked={value === p.id}
              onChange={() => onChange(p.id)}
            />
            <span>{describePlan(p)}</span>
            <strong>{formatPrice(p.prices[currency], currency)}</strong>
          </label>
        ))}
      </div>
      {other && (
        <button
          type="button"
          className="linklike promote__currency"
          onClick={() => onCurrencyChange(other)}
        >
          Show prices in {other === 'INR' ? 'rupees (₹)' : 'US dollars ($)'}
        </button>
      )}
    </>
  );
}
